import { axios } from "lib/axios";
import { useNotificationStore } from "stores/notifications";
import { useMutation } from "react-query";

export const joinWaitingList = ({ data }) => {
  return axios.post(`/users/join-waitlist`, data);
};

export const useJoinWaitingList = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: (data) => {
      addNotification({
        type: "success",
        title: data.msg,
      });
    },
    ...config,
    mutationFn: joinWaitingList,
  });
};
